var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.667,1h-8A.667.667,0,0,0,1,1.667v8a.667.667,0,0,0,.667.667h8a.667.667,0,0,0,.667-.667v-8A.667.667,0,0,0,9.667,1ZM9,9H2.333V2.333H9Zm7.333,1.333a4.667,4.667,0,1,0-4.667-4.667,4.667,4.667,0,0,0,4.667,4.667Zm0-8A3.333,3.333,0,1,1,13,5.667,3.333,3.333,0,0,1,16.333,2.333ZM9.667,11.667h-8A.667.667,0,0,0,1,12.333v8A.667.667,0,0,0,1.667,21h8a.667.667,0,0,0,.667-.667v-8A.667.667,0,0,0,9.667,11.667Zm-.667,8H2.333V13H9Zm11.333-8h-8a.667.667,0,0,0-.667.667v8a.667.667,0,0,0,.667.667h8A.667.667,0,0,0,21,20.333v-8A.667.667,0,0,0,20.333,11.667Zm-.667,8H13V13h6.667Z",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.e64d61b8adc2ac8db2620c9f5c7224a5.svg";
export { ForwardRef as ReactComponent };